import React from "react";
import Marquee from "react-fast-marquee";
import CelebrationIcon from "@mui/icons-material/Celebration";
import WhatshotIcon from "@mui/icons-material/Whatshot";

const Topad = () => {
  return (
    <div className="topad-container festive">
      <Marquee gradient={false} speed={65} pauseOnHover={true}>
        <div className="topad-text">
          <CelebrationIcon className="icon" />
          🎊 Festival Bonanza! Claim Your Winning Tokens Today!
          <WhatshotIcon className="icon" />
          🎁 Exclusive Rewards Await — Don’t Miss Your Chance!
        </div>
      </Marquee>
    </div>
  );
};

export default Topad;
